const toggleFavorites = event => {
    let target = event.target;
    var currentID = parseInt(target.id);

    if(target.classList.contains('heart--active')){
        target.classList.remove('heart--active');
    } else {
        target.classList.add('heart--active')
    }

    var favoritesLocalStorageObject = JSON.parse(localStorage.getItem('favorites') ?? '[]');
    var header_favorites_icon = document.getElementById("header__favorites--icon");

    if ( favoritesLocalStorageObject && favoritesLocalStorageObject.includes(currentID) ) {
        for (var i = 0; i < favoritesLocalStorageObject.length; i++) {
            if (favoritesLocalStorageObject[i]==currentID) favoritesLocalStorageObject.splice(i, 1);
        }
    } else {
        favoritesLocalStorageObject.push(currentID);
    }

    localStorage.setItem('favorites', JSON.stringify(favoritesLocalStorageObject));

    if ( favoritesLocalStorageObject?.length == 0 && header_favorites_icon && header_favorites_icon.classList.contains("header__favorites--icon-active") ) {
        document.getElementById("header__favorites--icon").classList.remove("header__favorites--icon-active");
    } else {
        document.getElementById("header__favorites--icon").classList.add("header__favorites--icon-active");
    }

    event.preventDefault();
}

export default toggleFavorites;